import { initSentry } from '@/lib/sentry';
initSentry();

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Auth0Provider, useAuth0 } from '@auth0/auth0-react';
import { QueryClientProvider } from '@tanstack/react-query';
import { AUTH0_CONFIG } from '@/lib/constants';
import { queryClient } from '@/lib/query-client';
import { setTokenGetter } from '@/lib/api';
import App from './App';
import '@/styles/globals.css';
import { useEffect } from 'react';

// eslint-disable-next-line react-refresh/only-export-components -- entry-point file, HMR not relevant
function Auth0TokenBridge() {
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    setTokenGetter(getAccessTokenSilently);
  }, [getAccessTokenSilently]);

  return null;
}

// eslint-disable-next-line react-refresh/only-export-components -- entry-point file, HMR not relevant
function Root() {
  return (
    <Auth0Provider
      domain={AUTH0_CONFIG.domain}
      clientId={AUTH0_CONFIG.clientId}
      authorizationParams={{
        redirect_uri: AUTH0_CONFIG.redirectUri,
        audience: AUTH0_CONFIG.audience,
      }}
    >
      <QueryClientProvider client={queryClient}>
        <Auth0TokenBridge />
        <App />
      </QueryClientProvider>
    </Auth0Provider>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
